export default function getCurrentUrl(href) {
  if (!href.includes('#')) {
    return href.split('?')[0];
  }

  var urlParts = href.split('?');
  return urlParts[0].split('#')[0];
}